import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { Http, ResponseContentType } from '@angular/http';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Reporte } from './Reporte.model';

export const DD_MM_YYYY_Format = {
	parse: {
		dateInput: 'LL',
	},
	display: {
		dateInput: 'DD/MM/YYYY',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

@Component({
	selector: 'cierre',
	templateUrl: './CierreFacturacionElectronica.component.html',
	providers: [
		{ provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_Format },
	]
})


export class CierreFacturacionElectronicaComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public reportes: Array<{}> = new Array();
	public campos: Array<{}> = new Array();
	public modelo: Array<any> = new Array();
	public nombreReporteXml: string = '';
	public nombreReporte: string = '';
	public link: string = '';

	public cargando: boolean = false;
	public label: string = '';

	public displayedColumns = ['VNOMBRECIERRE', 'INICIO', 'FIN', 'GENERAR'];
	public dataDataBase: ReporteDatabase;
	public dataSource: ExampleDataSource;
	public render: boolean = false;
	public cargandoReporte: boolean = false;
	public fechaCierre: string;


	constructor(private http: Http, private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();

		this.reportes.push(
			{
				nombreReporte: 'x',
				labelOpcion: 'CIERRE FACTURACIÓN ELECTRÓNICA',
				metadata: 'Fecha Inicio(mm-DD-yyyy):param_1_date|Fecha Fin(dd-mm-yyyy):param_2_date|Descripción Cierre(con esta descrición se podrá generar el reporte):param_3_string',
				rutaAlternaServicio: 'cierreFacturacionElectronica/'
			}
		);

		this._serviciosGenerales.get('fechaUltimoCierre', {}).subscribe(res => {
			this.fechaCierre = res[0].FIN;
		}, error => {
			this.openSnackBar("Ocurrió un error al cargar los datos", "X");
		})

	}



	pintar(item: any) {

		let metadata: string;
		metadata = item.metadata;

		console.log(' -- ', metadata);
		this.campos = new Array();
		this.modelo = new Array();

		if (item.generarTabla != undefined && item.generarTabla == true) {
			this.cargarTabla();
			this.render = true;
			return;
		} else {
			this.dataSource = new ExampleDataSource(new ReporteDatabase());
			this.render = false;
		}


		//console.log(this.modelo[100]);
		if (metadata != '') {
			for (let x of metadata.split('|')) {

				this.modelo.push('');
				let partes = x.split(':');
				let label = partes[0];
				let tipo = partes[1];
				if (label != 'hidden') {
					if (tipo.indexOf('string') > -1) {

						this.campos.push({ labelCampo: label, id: tipo, tipo: 'string', model: parseInt(tipo.substring(tipo.indexOf('_') + 1, tipo.lastIndexOf('_'))) });

					} else if (tipo.indexOf('date') > -1) {

						this.campos.push({ labelCampo: label, id: tipo, tipo: 'date', model: parseInt(tipo.substring(tipo.indexOf('_') + 1, tipo.lastIndexOf('_'))) });

					} else if (tipo.indexOf('list') > -1) {

						let tipoEspecial = tipo.split('=');
						let lista: Array<{}> = new Array();
						for (let y of tipoEspecial[1].split(',')) {
							let temp = y.split('&');
							lista.push({ label: temp[0], value: temp[1] });
						}
						this.campos.push({
							labelCampo: label, tipo: 'list',
							model: parseInt(tipoEspecial[0].substring(tipoEspecial[0].indexOf('_') + 1, tipoEspecial[0].lastIndexOf('_'))),
							value: lista, id: tipo.split('=')[0]
						});
					}
				} else {
					this.campos.push({
						labelCampo: label, id: tipo.split('=')[0], tipo: 'hidden',
						model: parseInt(tipo.split('=')[1].substring(tipo.split('=')[1].indexOf('_') + 1, tipo.split('=')[1].lastIndexOf('_')))
					});
				}
			}
		}
		console.log(this.campos);
	}

	generarReporteEspecial(elemento: any) {

		// Fecha Inicio(mm-DD-yyyy)(si no se filtra por este campo agregar un guion "-"):param_1_date|Fecha Fin(dd-mm-yyyy)(si no se filtra por este campo agregar un guion "-"):param_2_date|hidden:param_3_date=param_1_date|hidden:param_4_date=param_2_date|Negocio:param_5_list=TODOS&-,SOCIEDAD&PRODUCCION_CARTSOCFIDU,FACTUR&FACTUR,OPAIN&FIDUOPAIN,CORTISSOZ&CORTISSOZ,AIM&AIM,ORIENTE&ORIENTE|hidden:param_6_string=param_5_list|hidden:param_7_date=param_1_date|hidden:param_8_date=param_2_date|hidden:param_9_list=param_5_list|hidden:param_10_list=param_5_list|hidden:param_11_date=param_1_date|hidden:param_12_date=param_2_date|hidden:param_13_date=param_1_date|hidden:param_14_date=param_2_date|hidden:param_15_list=param_5_list|hidden:param_16_list=param_5_list

		let inicio: string = elemento.INICIO;
		let fin: string = elemento.FIN;

		console.log("GENERA REPORTE ESPECIAL ::::: ", elemento, ' ------ ', inicio, ' ----- ', fin);

		let parametros = {
			"param_1_string": inicio,
			"param_2_string": fin,
			"param_3_string": inicio,
			"param_4_string": fin,
			"param_5_string": "-",
			"param_6_string": "-",
			"param_7_string": inicio,
			"param_8_string": fin,
			"param_9_string": "-",
			"param_10_string": "-",
			"param_11_string": inicio,
			"param_12_string": fin,
			"param_13_string": inicio,
			"param_14_string": fin,
			"param_15_string": "-",
			"param_16_string": "-",






			"param_17_string": inicio,
			"param_18_string": fin,
			"param_19_string": inicio,
			"param_20_string": fin,
			"param_21_string": "-",
			"param_22_string": "-",
			"param_23_string": inicio,
			"param_24_string": fin,
			"param_25_string": "-",
			"param_26_string": "-",

			

			"param_27_string": inicio,
			"param_28_string": fin,
			"param_29_string": inicio,
			"param_30_string": fin,
			"param_31_string": "-",
			"param_32_string": "-",

			

			"param_33_string": inicio,
			"param_34_string": fin,
			"param_35_string": inicio,
			"param_36_string": fin,
			"param_37_string": "-",
			"param_38_string": "-",
			"param_39_string": inicio,
			"param_40_string": fin,
			"param_41_string": "-",
			"param_42_string": "-",

			

			"param_43_string": inicio,
			"param_44_string": fin,
			"param_45_string": inicio,
			"param_46_string": fin,
			"param_47_string": "-",
			"param_48_string": "-",



			"param_49_string": inicio,
			"param_50_string": fin,
			"param_51_string": inicio,
			"param_52_string": fin,
			"param_53_string": "-",
			"param_54_string": "-",
			"param_55_string": inicio,
			"param_56_string": fin,
			"param_57_string": "-",
			"param_58_string": "-",

			

			"param_59_string": inicio,
			"param_60_string": fin,
			"param_61_string": inicio,
			"param_62_string": fin,
			"param_63_string": "-",
			"param_64_string": "-",
			
		};
		console.log('->>>>>>>>>>$$##### ', parametros);
		/*parametros.param_1_date = new Date(Date.parse(inicio));
		parametros.param_2_date = new Date(Date.parse(fin));
		parametros.param_3_date = new Date(Date.parse(inicio));
		parametros.param_4_date = new Date(Date.parse(fin));
		parametros.param_7_date = new Date(Date.parse(inicio));
		parametros.param_8_date = new Date(Date.parse(fin));
		parametros.param_11_date = new Date(Date.parse(inicio));
		parametros.param_12_date = new Date(Date.parse(fin));
		parametros.param_13_date = new Date(Date.parse(inicio));
		parametros.param_14_date = new Date(Date.parse(fin));*/

		console.log('->>>>>>>>>> ', parametros);


		var info: string;

		this.cargando = true;

		this.nombreReporteXml = 'ReporteFacturacionElectronica';
		this.generarReporte(parametros);



	}

	generarReporte(temporal: any) {

		if (this.nombreReporteXml == undefined || this.nombreReporteXml == null || this.nombreReporteXml.split(' ').join('') == '') {
			this.openSnackBar("Hay que seleccionar un reporte", "X");
			return;
		}
		let parametros = {};

		if (temporal != undefined) {
			parametros = temporal;
		}
		console.log("COMO QUEDA PARAMETRO : ", parametros);

		for (let x of this.campos) {
			console.log('entrá')
			parametros[x['id']] = this.modelo[parseInt(x['model'])];
		}

		console.log("COMO QUEDA parametros : ", parametros);

		for (let x in parametros) {
			if (parametros[x] == undefined || (x.indexOf('date') == -1 ? parametros[x].trim() == '' : parametros[x] == null)) {
				this.openSnackBar("Hay campos obligatorios sin diligenciar", "X")
				return;
			}

			if (x.indexOf('date') > -1) {
				let fecha = new Date(parametros[x]);
				parametros[x] = fecha.getDate() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getFullYear();
			}
		}
		let rutaAlternaServicio: string = '';

		console.log("COMO QUEDA parametros : ", parametros);

		for (let x of this.reportes) {
			if (x['nombreReporte'] == this.nombreReporteXml) {
				rutaAlternaServicio = x['rutaAlternaServicio'];
			}
		}

		//this._serviciosGenerales.descargarArchivo('generar/excel/' + rutaAlternaServicio + this.nombreReporteXml, parametros);

		var info: string;

		this.cargando = true;
		this.cargandoReporte = true;

		console.log('----------------> ', rutaAlternaServicio);

		this._serviciosGenerales.get('generar/excel/' + rutaAlternaServicio + this.nombreReporteXml, parametros).subscribe(res => {
			console.log("----> ", res);

			if (res.retornoProcedimiento != undefined && res.retornoProcedimiento == true) {
				this.openSnackBar(res.info, "X");
			} else {
				/*info = res['_body'];*/
				info = 'data:application/octet-stream;base64,' + res.info;

				var dlnk = document.getElementById('dwnldLnk');
				dlnk['href'] = info;
				dlnk.click();

			}


			this.cargando = false;
			this.cargandoReporte = false;

			this._serviciosGenerales.get('fechaUltimoCierre', {}).subscribe(res => {
				this.fechaCierre = res[0].FIN;
			}, error => {
				this.openSnackBar("Ocurrió un error al cargar los datos", "X");
			})


		}, error => {
			console.log(error, '');
			this.openSnackBar("Ocurrió un error al momento de generar el reporte....", "X");
			this.cargando = false;
			this.cargandoReporte = false;
		})


		//this._serviciosGenerales.saveFile('generar/excel/'+this.nombreReporteXml, parametros)

		/*this.link = this._serviciosGenerales.path + '/generar/excel/' + this.nombreReporteXml +'/'+ encodeURIComponent(JSON.stringify(parametros)) + '/' + this._serviciosGenerales.seguridad.getToken();
		
		setTimeout( ()=>{
			document.getElementById('link').click();
		}, 500);*/

	}


	downloadFile() {
		return this.http
			.get('/facturacion/rest/generar/excel/prueba', {
				responseType: ResponseContentType.Blob,
				search: ''
			})
			.map(res => {
				return {
					filename: 'filename.xlsx',
					data: res.blob()
				};
			})
			.subscribe(res => {
				console.log('start download:', res);
				var url = window.URL.createObjectURL(res.data);
				var a = document.createElement('a');
				document.body.appendChild(a);
				a.setAttribute('style', 'display: none');
				a.href = url;
				a.download = res.filename;
				a.click();
				window.URL.revokeObjectURL(url);
				a.remove(); // remove the element
			}, error => {
				console.log('download error:', JSON.stringify(error));
			}, () => {
				console.log('Completed file download.')
			});
	}

	downloadFile2() {
		return this.http
			.get('/facturacion/rest/generar/excel/prueba2', {
				responseType: ResponseContentType.Blob,
				search: ''
			})
			.map(res => {
				return {
					filename: 'filename.xlsx',
					data: res.blob()
				};
			})
			.subscribe(res => {
				console.log('start download:', res);
				var url = window.URL.createObjectURL(res.data);
				var a = document.createElement('a');
				document.body.appendChild(a);
				a.setAttribute('style', 'display: none');
				a.href = url;
				a.download = res.filename;
				a.click();
				window.URL.revokeObjectURL(url);
				a.remove(); // remove the element
			}, error => {
				console.log('download error:', JSON.stringify(error));
			}, () => {
				console.log('Completed file download.')
			});
	}

	downloadFile3() {
		return this.http
			.get('/facturacion/rest/generar/excel/prueba3', {
				responseType: ResponseContentType.Blob,
				search: ''
			})
			.map(res => {
				return {
					filename: 'filename.xlsx',
					data: res.blob()
				};
			})
			.subscribe(res => {
				console.log('start download:', res);
				var url = window.URL.createObjectURL(res.data);
				var a = document.createElement('a');
				document.body.appendChild(a);
				a.setAttribute('style', 'display: none');
				a.href = url;
				a.download = res.filename;
				a.click();
				window.URL.revokeObjectURL(url);
				a.remove(); // remove the element
			}, error => {
				console.log('download error:', JSON.stringify(error));
			}, () => {
				console.log('Completed file download.')
			});
	}

	downloadFile4() {

		var info: string;

		this.http
			.get('/facturacion/rest/generar/excel/prueba4').subscribe(res => {
				console.log("OK ");

				info = res['_body'];
				info = 'data:application/octet-stream;base64,' + info;

				var dlnk = document.getElementById('dwnldLnk');
				dlnk['href'] = info;
				dlnk.click();

			}, error => {
				console.log("MAL ");
				console.log(error);
			})

	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


	public cargarTabla() {
		this.dataDataBase = new ReporteDatabase();

		this._serviciosGenerales.get('consultarCierres', { param: 0 }).subscribe(
			result => {

				for (let x of result) {
					let reporteModel: Reporte = new Reporte(x.VNOMBRECIERRE, x.INICIO, x.FIN, x.NIDCIERRE);
					this.dataDataBase.addNegocio(reporteModel);
					console.log("agrega negocio : ");
				}
				this.dataSource = new ExampleDataSource(this.dataDataBase);
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBar("Ocurrió un error al momento de cargar los cierres", "X");
			});
	}

}


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class ReporteDatabase {

	dataChange: BehaviorSubject<Reporte[]> = new BehaviorSubject<Reporte[]>([]);

	get data(): Reporte[] {
		return this.dataChange.value;
	}

	addNegocio(negocio: Reporte) {
		const copiedData = this.data.slice();
		copiedData.push(negocio);
		this.dataChange.next(copiedData);
	}

}


export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: ReporteDatabase) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<Reporte[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: Reporte) => {
				let searchStr = (item.VNOMBRECIERRE).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ReporteFacturacion/CierreFacturacionElectronica.component.ts